import { ConfigFilter } from "../types";

export const getConfigFilter = (filterName: string, configFilters: ConfigFilter[]) =>
  configFilters.find(item => item.name === filterName);
